"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "backgroundLiveToggled", {
  enumerable: true,
  get: function get() {
    return _backgroundLiveToggled["default"];
  }
});
var _backgroundLiveToggled = _interopRequireDefault(require("./backgroundLiveToggled"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }